import { Input, Tag, Menu } from "antd";
import AppCard from "@lib/components/AppComponents/AppCard";
import styled from "styled-components";
import { NoteTagType } from "@lib/types/Note";
import { FiTag, FiUser, FiShoppingBag, FiFileText } from "react-icons/fi";

const { Search } = Input;

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledSidebar = styled.div`
  width: 250px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.cardShadow}!important;

  @media screen and (max-width: 767px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
`;

export const StyledContent = styled.div`
  flex: 1;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  padding: 20px;
  box-shadow: ${({ theme }) => theme.cardShadow}!important;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const StyledFilterMenu = styled(Menu)`
  border-radius: 8px;
  box-shadow: none;
  border: none;
  border-inline-end: none;
  background: ${({ theme }) => theme.palette.background.paper};

  .ant-menu-item {
    svg {
      margin-right: 8px;
    }

    &.ant-menu-item-selected {
      background: ${({ theme }) => theme.palette.background.default};
      border: 1px solid ${({ theme }) => theme.palette.dividerColor};
    }
  }
`;

export const StyledMenuTitle = styled.div`
  padding: 15px 20px 10px 20px;
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.primary}!important;
  background: ${({ theme }) => theme.palette.background.paper}!important;
  border-top-left-radius: ${({ theme }) => theme.cardRadius}!important;
  border-top-right-radius: ${({ theme }) => theme.cardRadius}!important;
  border-bottom: 1px solid
    ${({ theme }) => theme.palette.dividerColor}!important;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  width: 100%;
`;

export const StyledSearch = styled(Search)`
  max-width: 500px;
  width: 100%;
  padding: 10px;
`;

export const StyledNoteCard = styled(AppCard)`
  height: 100%;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${({ theme }) => theme.palette.background.default}!important;
  color: ${({ theme }) => theme.palette.text.primary}!important;
  border: 1px solid ${({ theme }) => theme.palette.dividerColor};
  padding: 10px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }

  .note-content {
    margin-top: 8px;
  }

  .note-date {
    margin-top: 12px;
    font-size: 12px;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export const StyledNoteTags = styled.div`
  margin-top: 12px;
  color: ${({ theme }) => theme.palette.text.primary}!important;
`;

export const StyledNoteTag = styled(Tag)`
  margin-right: 4px;
  background: ${({ theme }) => theme.palette.background.paper}!important;
  color: ${({ theme }) => theme.palette.text.primary}!important;
`;

export const StyledResponsiveContainer = styled.div`
  display: flex;
  gap: 10px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  display: flex;
  width: 100%;
`;

export const FilterIcon = ({ type }: { type?: NoteTagType }) => {
  switch (type) {
    case NoteTagType.CUSTOMER:
      return <FiUser />;
    case NoteTagType.PRODUCT:
      return <FiShoppingBag />;
    case NoteTagType.INVOICE:
      return <FiFileText />;
    default:
      return <FiTag />;
  }
};
